@if (showSearch || showFilters || (showCreateButton && !showSearch || !showFilters)) {
  <div class="flex items-start mb-6">
    <div class="flex flex-wrap items-center gap-y-3 flex-1 min-w-0">
      <!-- Buscador -->
      @if (showSearch) {
        <div class="flex-1 min-w-[180px] max-w-[400px]">
          <app-searchbox
            [placeholder]="'Buscar...'"
            (searchChange)="searchChange.emit($event)"
          ></app-searchbox>
        </div>
      }

      @if (showFilters) {
        <!-- Filtros dinámicos -->
        <div class="flex items-center gap-2 ml-2 sm:gap-2 flex-shrink-0">
          <ng-container *ngFor="let key of objectKeys(filterOptions)">
            <app-dropdown-simple
              class="sm560:flex hidden"
              [placeholder]="filterLabels[key] || key"
              [options]="filterOptions[key]"
              [dropdownId]="key"
              backgroundColor="bg-secundary-b600"
              [hasShadow]="false"
              textColor="text-text-primary"
              arrowColor="text-soft-gray"
              selectedBgColor="bg-primary-g50"
              selectedTextColor="text-primary"
              selectedBorderColor="border-primary-g300"
              hoverBgColor="hover:bg-primary-g100"
              optionTextColor="text-primary"
              (selectionChange)="onFilterChange(key, $event.value)"
            ></app-dropdown-simple>
          </ng-container>

          <!-- Toggle filtros móvil -->
          <button 
            class="sm560:hidden flex items-center gap-2 pr-2 py-2 text-primary rounded-lg hover:bg-gray-50 transition-colors"
            (click)="toggleMobileFilters()"
          >
            <i class="fi fi-br-bars-filter text-sm"></i>
            <span class="text-base font-medium">
              {{ showMobileFilters ? 'Ocultar filtros' : 'Mostrar filtros' }}
            </span>
          </button>

          <!-- Limpiar filtros -->
          <button 
            class="text-base font-medium transition-colors whitespace-nowrap px-2 py-1 leading-6"
            [ngClass]="{
              'text-text-placeholder hover:text-gray-700': !hasActiveFilters(),
              'text-gray-800 hover:text-gray-900': hasActiveFilters()
            }"
            (click)="clearFilters()"
          >
            Limpiar filtros
          </button>
        </div>
      }
    </div>
    <ng-content></ng-content>

    <!-- Botón Crear -->
    @if (showCreateButton) {
      <div class="flex-shrink-0 ml-3">
        <app-buttons
          class="hidden sm560:flex"
          [type]="'primary'"
          [size]="'medium'"
          [text]="createButtonText"
          [icon]="createButtonIcon"
          (buttonClick)="onCrearProducto()"
        ></app-buttons>
        <button 
          class="flex sm560:hidden bg-primary-g300 w-12 h-12 text-white rounded-2xl justify-center items-center transition-colors hover:bg-primary-g500"
          (click)="onCrearProducto()"
        >
          <i class="{{ createButtonIcon }} text-xl leading-none justify-center items-center mt-[2px]"></i>
        </button>
      </div>
    }
  </div>
}

<!-- Mobile filters -->
@if (showMobileFilters && showFilters) {
  <div class="sm560:hidden mb-4 pt-2 pl-2 -mt-6">
    <div class="flex flex-wrap items-center gap-3">
      <ng-container *ngFor="let key of objectKeys(filterOptions)">
        <div class="flex-shrink-0">
          <app-dropdown-simple
            [placeholder]="filterLabels[key] || key"
            [options]="filterOptions[key]"
            [dropdownId]="key + 'Mobile'"
            backgroundColor="bg-secundary-b600"
            [hasShadow]="false"
            textColor="text-primary"
            arrowColor="text-soft-gray"
            selectedBgColor="bg-primary-g50"
            selectedTextColor="text-primary"
            selectedBorderColor="border-primary-g300"
            hoverBgColor="hover:bg-primary-g100"
            optionTextColor="text-primary"
            (selectionChange)="onFilterChange(key, $event.value)"
          ></app-dropdown-simple>
        </div>
      </ng-container>
    </div>
  </div>
}